import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { Nav, Button, Container, Modal } from 'react-bootstrap'; // Type defintitions

import * as TYPES from '../../types'; // JSS

import { Link } from '@sitecore-jss/sitecore-jss-react'; // Design System

import Logo from "../Logo";
import WaitListButton from "../forms/WaitlistButton"; //ga tracker

import gaTracker from '../../util/ga-analytics/gaTracker';

var SecondaryMenu = /*#__PURE__*/function (_Component) {
  _inherits(SecondaryMenu, _Component);

  var _super = _createSuper(SecondaryMenu);

  function SecondaryMenu(props) {
    var _this;

    _classCallCheck(this, SecondaryMenu);

    _this = _super.call(this, props);

    _this.pushGaEvent = function (id) {
      var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var htmlid = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
      var event = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'click';
      var data = {
        gtm: {
          uniqueEventId: id,
          // '22'
          elementUrl: url,
          elementId: htmlid
        },
        event: 'gtm.' + event
      };
      gaTracker(data);
    };

    _this.menuClick = function (href, id) {
      _this.pushGaEvent(22, href, id);
    };

    _this.menuButtonClick = function () {
      var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

      _this.pushGaEvent(25, "", id);
    };

    _this.state = {
      secondaryNavVisible: props.secondaryNavVisible,
      showPayInApp: props.showPayInApp
    };
    return _this;
  }

  _createClass(SecondaryMenu, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var secondaryNavVisible = this.props.secondaryNavVisible;

      if (prevProps.secondaryNavVisible !== secondaryNavVisible) {
        this.setState({
          secondaryNavVisible: secondaryNavVisible
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          onHide = _this$props.onHide,
          model = _this$props.model,
          links = _this$props.links,
          onLogin = _this$props.onLogin,
          onLogout = _this$props.onLogout,
          toggleWaitlist = _this$props.toggleWaitlist,
          authenticationState = _this$props.authenticationState,
          isStorePortal = _this$props.isStorePortal;
      var _this$state = this.state,
          secondaryNavVisible = _this$state.secondaryNavVisible,
          showPayInApp = _this$state.showPayInApp;

      if (isStorePortal) {
        return /*#__PURE__*/React.createElement(Container, {
          className: "position-absolute"
        }, /*#__PURE__*/React.createElement(Modal, {
          className: "cb-menu-secondary",
          show: secondaryNavVisible,
          onHide: onHide,
          autoFocus: true,
          keyboard: true
        }, /*#__PURE__*/React.createElement(Modal.Header, {
          closeButton: true
        }, /*#__PURE__*/React.createElement("div", {
          className: "cb-menu-secondary__logo--lg"
        }, /*#__PURE__*/React.createElement(Logo, {
          model: model
        }))), /*#__PURE__*/React.createElement(Modal.Body, null, /*#__PURE__*/React.createElement(Nav, {
          className: "cb-menu-secondary__nav",
          as: "ul"
        }, /*#__PURE__*/React.createElement(Nav.Link, {
          as: "li"
        }, /*#__PURE__*/React.createElement("a", {
          href: "/shop/orders",
          id: "orders-list"
        }, "Orders List"))))));
      }

      return /*#__PURE__*/React.createElement(Container, {
        className: "position-absolute"
      }, /*#__PURE__*/React.createElement(Modal, {
        className: "cb-menu-secondary",
        show: secondaryNavVisible,
        onHide: onHide,
        autoFocus: true,
        keyboard: true
      }, /*#__PURE__*/React.createElement(Modal.Header, {
        closeButton: true
      }, /*#__PURE__*/React.createElement("div", {
        className: "cb-menu-secondary__logo--lg"
      }, /*#__PURE__*/React.createElement(Logo, {
        model: model
      }))), /*#__PURE__*/React.createElement(Modal.Body, null, /*#__PURE__*/React.createElement(Nav, {
        className: "cb-menu-secondary__nav",
        as: "ul"
      }, authenticationState !== 'Authenticated' ? /*#__PURE__*/React.createElement(Nav.Link, {
        as: "li",
        id: "secondary-signin"
      }, /*#__PURE__*/React.createElement("a", {
        href: "#",
        onClick: function onClick(e) {
          e.preventDefault();
          return onLogin();
        }
      }, "Sign in or Sign Up")) : null, authenticationState === 'Authenticated' ? /*#__PURE__*/React.createElement(Nav.Link, {
        as: "li"
      }, /*#__PURE__*/React.createElement("a", {
        href: "/rewards/my-info"
      }, "My Account")) : null, authenticationState === 'Authenticated' ? /*#__PURE__*/React.createElement(Nav.Link, {
        as: "li"
      }, /*#__PURE__*/React.createElement("a", {
        href: "/rewards/my-info/my-orders",
        id: "secondary-account"
      }, "Order History")) : null, links === null || links === void 0 ? void 0 : links.children.map(function (linkobj, index) {
        var _linkobj$link, _linkobj$link2;

        return /*#__PURE__*/React.createElement(Nav.Link, {
          as: "li",
          key: "secondarynav-".concat(index)
        }, /*#__PURE__*/React.createElement("a", {
          href: (_linkobj$link = linkobj.link) === null || _linkobj$link === void 0 ? void 0 : _linkobj$link.url,
          id: "secondarynav-".concat(index)
        }, (_linkobj$link2 = linkobj.link) === null || _linkobj$link2 === void 0 ? void 0 : _linkobj$link2.text));
      }), authenticationState === 'Authenticated' ? /*#__PURE__*/React.createElement(Nav.Link, {
        as: "li"
      }, /*#__PURE__*/React.createElement("a", {
        href: "#",
        onClick: function onClick(e) {
          e.preventDefault();
          onLogout();
        }
      }, "Logout")) : null), /*#__PURE__*/React.createElement("ul", {
        className: "cb-menu-secondary__actions"
      }, !this.props.temporarilyClosed && !this.props.orderOnline && /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(Link, {
        field: {
          'href': '/menu',
          'text': 'Order Online',
          'class': 'cb-button-primary w-100',
          'onClick': function onClick() {
            return _this2.menuButtonClick("secondary-orderonline");
          }
        },
        id: "secondary-orderonline"
      })), !this.props.temporarilyClosed && this.props.waitlistAvailable && /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(WaitListButton, {
        store: this.props.store,
        className: "w-100",
        ctaClick: function ctaClick() {
          toggleWaitlist();

          _this2.menuButtonClick("secondary-joinwaitlist");
        }
      })), showPayInApp && /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
        href: "#",
        className: "cb-button-secondary w-100",
        onClick: this.props.openPayInApp
      }, "Pay Dine-In Check"))))));
    }
  }]);

  return SecondaryMenu;
}(Component);

export { SecondaryMenu as default };